import styled, { css } from 'styled-components';

import { Text, Button, Tag } from '@gympass/yoga';
import { ChevronDown, ChevronUp } from '@gympass/yoga-icons';

import Table from 'components/Table';

export const StyledTable = styled(Table)`
  thead tr {
    border-bottom: ${({ theme }) =>
        `${theme.yoga.colors.tableBorder} ${theme.yoga.borders.small}px`}
      solid;

    th {
      text-transform: none;
      font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 90%;
`;

export const NoDataContainer = styled.div`
  margin: auto;
  display: flex;
  align-items: center;
`;

export const NoDataContent = styled.div`
  max-width: ${({ theme }) =>
    theme.yoga.sizes.sessionHistoryNoDataContentMaxWidth}px;
`;

export const NoDataTitle = styled(Text.Medium)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const CentrilizedContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TableHeaderText = styled(Text.Small)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  color: ${({ theme, isOrdered }) =>
    isOrdered ? theme.yoga.colors.primary : theme.yoga.colors.stamina};
`;

export const OrderButton = styled(Button.Text)`
  padding: 0;
  margin-left: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

const arrowsStyles = (color: string) => css`
  fill: ${color} !important;
  width: ${({ theme }) => theme.yoga.spacing.small}px !important;
  height: ${({ theme }) => theme.yoga.spacing.small}px !important;
`;

export const NonOrdered = styled(ChevronDown)`
  ${({ theme }) => arrowsStyles(theme.yoga.colors.stamina)}
`;

export const DescOrdered = styled(ChevronDown)`
  ${({ theme }) => arrowsStyles(theme.yoga.colors.primary)}
`;

export const AscOrdered = styled(ChevronUp)`
  ${({ theme }) => arrowsStyles(theme.yoga.colors.primary)}
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const TagContainer = styled.div`
  text-indent: ${({ theme }) => theme.yoga.spacing.zero};
  margin-left: ${({ theme }) => theme.yoga.spacing.large}px;
  display: flex;
  flex-direction: row;
`;

const baseTagStyle = css`
  margin-right: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const ActionTag = styled(Tag.Informative)`
  ${baseTagStyle};
`;

export const InitialSessionTag = styled(Tag)`
  ${baseTagStyle};
`;
